/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_New_StoryInputs */

const en_story_bank_new_story = /** @type {(inputs: Story_Bank_New_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Story`)
};

const de_story_bank_new_story = /** @type {(inputs: Story_Bank_New_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Story`)
};

const fr_story_bank_new_story = /** @type {(inputs: Story_Bank_New_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Story`)
};

const es_story_bank_new_story = /** @type {(inputs: Story_Bank_New_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Story`)
};

const it_story_bank_new_story = /** @type {(inputs: Story_Bank_New_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Story`)
};

const nl_story_bank_new_story = /** @type {(inputs: Story_Bank_New_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Story`)
};

const pl_story_bank_new_story = /** @type {(inputs: Story_Bank_New_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Story`)
};

const fi_story_bank_new_story = /** @type {(inputs: Story_Bank_New_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Story`)
};

const da_story_bank_new_story = /** @type {(inputs: Story_Bank_New_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Story`)
};

const sv_story_bank_new_story = /** @type {(inputs: Story_Bank_New_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Story`)
};

/**
* | output |
* | --- |
* | "New Story" |
*
* @param {Story_Bank_New_StoryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_new_story = /** @type {((inputs?: Story_Bank_New_StoryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_New_StoryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_new_story(inputs)
	if (locale === "fr") return fr_story_bank_new_story(inputs)
	if (locale === "es") return es_story_bank_new_story(inputs)
	if (locale === "it") return it_story_bank_new_story(inputs)
	if (locale === "nl") return nl_story_bank_new_story(inputs)
	if (locale === "pl") return pl_story_bank_new_story(inputs)
	if (locale === "fi") return fi_story_bank_new_story(inputs)
	if (locale === "da") return da_story_bank_new_story(inputs)
	if (locale === "sv") return sv_story_bank_new_story(inputs)
	return en_story_bank_new_story(inputs)
});